// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__A--Th","skillsContainer":"Skills_skillsContainer__NAEPy","title":"Skills_title__dWKFA","skills":"Skills_skills__DzBSQ"};